import React from 'react';
import { cn } from './cn';
import { getPlatformDisplayName } from '../../utils/propertyPlatforms';

const LABELS = {
  bazaraki: 'Bazaraki',
  buysellcyprus: 'BuySell',
  buysell: 'BuySell',
  domcom: 'DOM',
  dom: 'DOM',
  altia: 'Altia',
  remu: 'REMU',
};

export const platformLabel = (platform) => {
  if (!platform) return null;
  const key = String(platform).toLowerCase();
  if (LABELS[key]) return LABELS[key];
  try {
    return getPlatformDisplayName(platform) || platform;
  } catch {
    return platform;
  }
};

/** Muted blue chip naming the source platform. Renders nothing without a platform. */
const PlatformBadge = ({ platform, className, size = 'sm' }) => {
  const label = platformLabel(platform);
  if (!label) return null;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md font-semibold bg-info/90 text-white shadow-sm',
        size === 'sm' ? 'px-1.5 py-0.5 text-[11px]' : 'px-2 py-1 text-xs',
        className
      )}
    >
      {label}
    </span>
  );
};

export default PlatformBadge;
